<template>
    <div class="APP_informationList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.id" placeholder="请输入消息ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.title" placeholder="请输入消息标题"></el-input>
                </el-form-item>

                <el-select size v-model="searchForm.is_pass" clearable placeholder="请选择审核状态">
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="通过" value="2"></el-option>
                    <el-option label="拒绝" value="3"></el-option>
                </el-select>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addNotice">添加消息</el-button>
            </div>
            <el-table
                :data="informationList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
                max-height="500px"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 标题 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="title"
                    label="标题"
                    min-width="120"
                ></el-table-column>
                <!-- 创建时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="创建时间"
                    min-width="150"
                ></el-table-column>
                <!-- 状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status"
                    label="状态"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-text="显示"
                            inactive-text="隐藏"
                            :active-value="1"
                            :inactive-value="0"
                            @change="statusChange(scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="is_pass"
                        label="审核状态"
                        min-width="150"
                        :formatter="formatStatus"
                        v-if="level == 0"
                ></el-table-column>

                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_id"
                        label="来源"
                        min-width="150"
                        :formatter="formatAgent"
                ></el-table-column>

                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>&nbsp;
                        <el-popconfirm
                            title="是否确认删除此消息？"
                            @onConfirm="handleDel(scope.row)"
                            v-if="scope.row.status == 0"
                        >
                            <el-button slot="reference" type="text" size="small">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "APP_informationList",
    data() {
        return {
            informationList: [], //table
            searchForm: {
                page: 1,
                limit: 10,
                id: '',
                title: ''
            },
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            flag: true, //删除防重复
            level:sessionStorage.getItem('level'),
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
        addNotice() { //添加消息
            this.$router.push({ path: '/informationInfo', query: { type: 0 } });
            this.$route.meta.title = '添加消息';
        },
        handleEdit(row) { //编辑
            this.$router.push({ path: '/informationInfo', query: { type: 1, id: row.id } });
            this.$route.meta.title = '编辑消息';
        },
        handleDel(row) { //删除
            if (this.flag) {
                this.flag = false;
                this.$api.post('system_message/del_message', { id: row.id }, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.getData({
                            page: this.currentPage,
                            limit: this.pageSize
                        })
                        this.flag = true;
                    } else {
                        this.$message.error(res.msg);
                        this.flag = true;
                    }
                })
            }
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("system_message/get_message_list", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.informationList = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        statusChange(row) { //改变状态
            this.$api.post('system_message/edit_system_message_status', {
                id: row.id,
                status: row.status
            }, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                    row.status = row.status == 0 ? 1 : 0;
                }
            })
        },
        formatStatus(row) { //格式化当前状态
            var status = '';
            switch (row.is_pass) {
                case 1:
                    status = '待审核';
                    break;

                case 2:
                    status = '通过';
                    break;

                case 3:
                    status = '拒绝';
                    break;
                default:
                    status = '';
                    break;
            }
            return status;
        },
        formatAgent(row) { //格式化当前状态
            var agent_id = '';
            switch (row.agent_id) {
                case 0:
                    agent_id = '总平台';
                    break;
                default:
                    agent_id = '平台';
                    break;
            }
            return agent_id;
        },
    }
};
</script>

<style lang="scss" scoped>
.APP_informationList {

}
</style>
